// src/pages/SellerSuccess/VerifyingState.jsx
import React from 'react';
import { sellerSuccessStyles } from './styles';

const VerifyingState = () => {
  return (
    <div style={sellerSuccessStyles.statusContent}>
      <div style={sellerSuccessStyles.heroSection}>
        <div style={sellerSuccessStyles.iconContainer}>
          <div style={sellerSuccessStyles.loadingSpinner}></div>
        </div>
        <h1 style={sellerSuccessStyles.title}>Verifying Your Account</h1>
        <p style={sellerSuccessStyles.description}>
          We're confirming your seller setup with Stripe and activating your account. 
          This usually takes just a few moments.
        </p>
        <div style={sellerSuccessStyles.loadingText}>
          Setting up your seller dashboard...
        </div>
      </div>
    </div>
  );
};

export default VerifyingState;